
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHydraulic08On as ObiHydraulic08OnElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-hydraulic-08-on.js';
 
 
 

 
 export const ObiHydraulic08On = createComponent({
   react: React,
   tagName: 'obi-hydraulic-08-on',
   elementClass: ObiHydraulic08OnElement,
   events: {
     
   }
  });
 
 